module.exports = __webpack_public_path__ + "images/category_lp/bike/assessment_achievements/2_785ae90730c905531fbe01a04a3dd462.jpg";